import { Button, ButtonVariant } from "@amzn/stencil-react-components/button";
import { Card } from "@amzn/stencil-react-components/card";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import IconPencilSmall from "@amzn/stencil-react-icons/icons/icon-pencil-small";
import React, { FC } from "react";

export interface SummaryBlockProps {
  heading: string;
  lines: string[];
  onEdit: () => void;
  editLabel: string;
  editAccessibleName?: string;
  dataTestId: string;
}

export const SummaryBlock: FC<SummaryBlockProps> = ({
  heading,
  lines,
  onEdit,
  editLabel,
  editAccessibleName,
  dataTestId,
}) => (
  <Card dataTestId={dataTestId} width="100%">
    <Col gridGap="S200" width="100%">
      <Row justifyContent="space-between" alignItems="center" gridGap="S300" width="100%">
        <Text fontSize="T300" fontWeight="bold">
          {heading}
        </Text>
        <Button
          variant={ButtonVariant.TertiaryInline}
          onClick={onEdit}
          aria-label={editAccessibleName}
          icon={<IconPencilSmall aria-hidden={true} />}
          data-testid={`${dataTestId}-edit`}
        >
          {editLabel}
        </Button>
      </Row>
      <Col gridGap="S100">
        {lines.map((line) => (
          <Text key={line}>{line}</Text>
        ))}
      </Col>
    </Col>
  </Card>
);
